// extracted by mini-css-extract-plugin
export default {"btn":"IntVideoBtn_btn__lgeW9","icon":"IntVideoBtn_icon__0KcjB"};